// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__fCFy0","description":"styles_description__OYjh6","wrapper":"styles_wrapper__WzfMI","logo":"styles_logo__j3yFn"};